// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8a202026","239":"8cef9898","455":"a230a65e"}[chunkId] + ".chunk.js";
};